import FilterForm from '../../../components/forms/FilterForm';
import { CanAccess, HttpError } from '@refinedev/core';
import { DatePicker, Flex, Form, Input, Space, Table } from 'antd';
import { EditButton, TagField, TextField, useTable } from '@refinedev/antd';
import { EyeOutlined, SearchOutlined } from '@ant-design/icons';
import { IGraduateDiscipline } from 'interfaces/graduate_disciplines';
import { IGraduateModule } from 'interfaces/graduate_courses';
import { ListLayout } from 'components/layout/layout/ListLayout';

interface IFilter {
  name: string;
  externalRef: string;
  created_at: string;
}

export const GraduateDisciplineList = () => {
  const { tableProps, searchFormProps } = useTable<
    IGraduateDiscipline,
    HttpError,
    IFilter
  >({
    onSearch: params => {
      const { name, externalRef, created_at } = params;

      return [
        {
          field: 'filter[name]',
          operator: 'eq',
          value: name
        },
        {
          field: 'filter[search_external_reference]',
          operator: 'eq',
          value: externalRef
        },
        {
          field: 'filter[created_at]',
          operator: 'eq',
          value: created_at
        }
      ];
    },
    sorters: {
      mode: 'server'
    }
  });

  return (
    <ListLayout title="Disciplinas">
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="name">
          <Input
            placeholder="Buscar pelo nome da disciplina"
            className="min-w-[300px]"
            suffix={<SearchOutlined />}
          />
        </Form.Item>

        <Form.Item name="externalRef">
          <Input placeholder="Código da externo" />
        </Form.Item>

        <Form.Item name="created_at">
          <DatePicker
            placeholder="Data de criação"
            format="DD/MM/YYYY"
            className="w-full"
          />
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id" tableLayout="fixed">
        <Table.Column
          dataIndex="code"
          key="code"
          title="Código"
          width={100}
          sorter
          fixed="left"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="name"
          key="name"
          width={200}
          title="Nome"
          sorter
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="duration_in_minutes"
          key="duration_in_minutes"
          width={100}
          title="Duração (minutos)"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="created_at"
          key="created_at"
          width={120}
          title="Data de criação"
          sorter
          render={value => (
            <TextField value={new Date(value).toLocaleDateString('pt-BR')} />
          )}
        />
        <Table.Column
          dataIndex="updated_at"
          key="updated_at"
          width={130}
          title="Última atualização"
          sorter
          render={value => (
            <TextField value={new Date(value).toLocaleDateString('pt-BR')} />
          )}
        />
        <Table.Column
          dataIndex="modules"
          key="modules"
          title="Modulos"
          render={modules => {
            return (
              <Flex wrap="wrap" gap={6}>
                {modules.map((module: IGraduateModule, idx: number) => (
                  <TagField
                    key={`modulo-${idx}`}
                    value={module.name}
                    className="mr-0"
                  />
                ))}
              </Flex>
            );
          }}
        />
        <Table.Column
          dataIndex="external_reference"
          key="external_reference"
          title="Código externo"
          render={value => <TextField value={value ?? '-'} />}
        />
        <Table.Column<IGraduateDiscipline>
          title="Ações"
          dataIndex="actions"
          align="center"
          fixed="right"
          width={60}
          render={(_, record) => {
            return (
              <Space>
                <CanAccess resource="graduate_disciplines" action="show">
                  <EditButton
                    hideText
                    size="small"
                    recordItemId={record.id}
                    icon={<EyeOutlined />}
                  />
                </CanAccess>
              </Space>
            );
          }}
        />
      </Table>
    </ListLayout>
  );
};
